import React from 'react';

export const Home = () => {
  return (
    <div className="container mx-auto px-4 h-[calc(100vh-8rem)] flex items-center">
      <div className="max-w-4xl mx-auto text-center">
        {/* Name */}
        <h1 className="text-7xl font-bold mb-6 opacity-0 animate-slide-up">
          <span className="bg-gradient-to-r from-white via-white/90 to-white text-transparent bg-clip-text">
            Aakarsh Kaushal
          </span>
        </h1>

        {/* Title */}
        <h2 className="text-3xl font-medium mb-8 text-white/90 opacity-0 animate-slide-up animation-delay-200">
          Software Engineer
        </h2>

        {/* Description */}
        <p className="text-xl text-white/80 mb-12 max-w-2xl mx-auto leading-relaxed opacity-0 animate-slide-up animation-delay-300">
          I'm passionate about building innovative solutions and creating impactful software. 
          Focused on full-stack development, cloud technologies, and artificial intelligence.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-6 justify-center opacity-0 animate-slide-up animation-delay-400">
          <a
            href="https://drive.google.com/file/d/1hHhWBFJbbGThIt665M3m1IxbnfueUvOR/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-[180px] px-8 py-3 text-lg font-medium rounded-lg 
              overflow-hidden
              bg-gradient-to-br from-purple-600/20 to-pink-500/20
              border border-white/20
              text-white
              transition-all duration-300
              hover:border-white/40
              hover:shadow-[0_0_20px_-5px] hover:shadow-purple-500/50
              before:absolute before:inset-0
              before:bg-gradient-to-br before:from-purple-600 before:to-pink-500
              before:opacity-0 before:transition-opacity before:duration-300
              hover:before:opacity-20
              after:absolute after:inset-0
              after:bg-gradient-to-br after:from-purple-600/10 after:to-pink-500/10
              after:opacity-0 after:transition-opacity after:duration-300
              hover:after:opacity-100"
          >
            <span className="relative z-10">View Resume</span>
          </a>
          <a
            href="mailto:aakarshkaushal911@gmail.com"
            className="group relative w-[180px] px-8 py-3 text-lg font-medium rounded-lg 
              overflow-hidden
              bg-gradient-to-br from-blue-600/20 to-cyan-500/20
              border border-white/20
              text-white/90
              transition-all duration-300
              hover:text-white
              hover:border-white/40
              hover:shadow-[0_0_20px_-5px] hover:shadow-blue-500/50
              before:absolute before:inset-0
              before:bg-gradient-to-br before:from-blue-600 before:to-cyan-500
              before:opacity-0 before:transition-opacity before:duration-300
              hover:before:opacity-20
              after:absolute after:inset-0
              after:bg-gradient-to-br after:from-blue-600/10 after:to-cyan-500/10
              after:opacity-0 after:transition-opacity after:duration-300
              hover:after:opacity-100"
          >
            <span className="relative z-10">Contact Me</span>
          </a>
        </div>
      </div>
    </div>
  );
}; 